import Plyr from "plyr";

let players = [];

export default {
    init: function () {
        document.querySelectorAll(".plyr-video").forEach((player_el) => {
            const player = new Plyr(player_el);
            players = [...players, player];
        });
    },
    cleanup: function () {
        players.forEach((player) => {
            player.destroy();
        });
        players = [];
    }
};
